<template>
  <div :class="['apps-grid-wrap', 'apps-mode-' + mode]">
    <!-- 头部：标题 + 分类 tab（section 模式带标题） -->
    <div v-if="mode === 'section'" class="apps-section-header">
      <h2 class="apps-section-title">{{ $t('home.apps.title') }}</h2>
      <div class="apps-section-tabs">
        <button
          v-for="cat in categories"
          :key="cat.key"
          :class="['apps-section-tab', { active: activeTab === cat.key }]"
          @click="activeTab = cat.key"
        >{{ cat.label }}</button>
      </div>
    </div>
    <!-- modal 模式只有 tab -->
    <div v-if="mode === 'modal'" class="apps-modal-tabs">
      <button
        v-for="cat in categories"
        :key="cat.key"
        :class="['apps-modal-tab', { active: activeTab === cat.key }]"
        @click="activeTab = cat.key"
      >{{ cat.label }}</button>
    </div>
    <!-- 卡片网格 -->
    <template v-if="mode === 'section'">
      <div class="apps-section-grid">
        <router-link
          v-for="app in currentApps"
          :key="app.key"
          :to="appLink(app.key)"
          :class="['apps-section-card', app.video ? 'is-video' : 'is-image']"
          @mouseenter.native="onCardEnter($event)"
          @mouseleave.native="onCardLeave($event)"
        >
          <video
            v-if="app.video"
            :data-src="app.video"
            :poster="app.poster"
            class="apps-section-card-video"
            loop
            muted
            playsinline
            preload="none"
          ></video>
          <img v-else :src="app.image" :alt="app.name" class="apps-section-card-img" />
          <div class="apps-section-card-overlay">
            <h3 class="apps-section-card-name">{{ app.name }}</h3>
          </div>
        </router-link>
      </div>
    </template>
    <template v-if="mode === 'modal'">
      <div v-for="cat in categories" :key="cat.key" v-show="activeTab === cat.key" class="apps-modal-grid">
        <router-link
          v-for="app in appsMap[cat.key]"
          :key="app.key"
          :to="appLink(app.key)"
          class="apps-modal-card"
          @mouseenter.native="onCardEnter($event)"
          @mouseleave.native="onCardLeave($event)"
          @click.native="onAppClick"
        >
          <video
            v-if="app.video"
            :data-src="app.video"
            :poster="app.poster"
            class="apps-modal-card-video"
            loop
            muted
            playsinline
            preload="none"
          ></video>
          <img v-else :src="app.image" :alt="app.name" class="apps-modal-card-img" />
          <div class="apps-modal-card-overlay">
            <span class="apps-modal-card-name">{{ app.name }}</span>
          </div>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
var appConfig = require('../config/appConfig')

module.exports = {
  name: 'AppsGrid',
  props: {
    /* 'section' 用于首页内嵌区块, 'modal' 用于弹窗内展示 */
    mode: {
      type: String,
      default: 'section',
      validator: function (v) { return v === 'section' || v === 'modal' }
    }
  },
  data: function () {
    return {
      activeTab: 'social',
      _playingVideo: null
    }
  },
  computed: {
    categories: function () {
      return appConfig.getAppCategories(this.$t.bind(this))
    },
    appsMap: function () {
      return appConfig.getAppMap(this.$t.bind(this))
    },
    currentApps: function () {
      return this.appsMap[this.activeTab] || []
    }
  },
  methods: {
    appLink: function (appKey) {
      var lang = this.$route.params.lang
      return lang ? '/' + lang + '/apps/' + appKey : '/apps/' + appKey
    },
    onCardEnter: function (e) {
      var video = e.currentTarget.querySelector('video')
      if (!video) return
      // 暂停上一个正在播放的视频
      if (this._playingVideo && this._playingVideo !== video) {
        this._playingVideo.pause()
        this._playingVideo.currentTime = 0
      }
      // 懒加载：首次 hover 才赋值 src
      if (!video.src) {
        var src = video.getAttribute('data-src')
        if (src) video.src = src
      }
      if (typeof video.play === 'function') {
        var self = this
        video.play().catch(function () {})
        self._playingVideo = video
      }
    },
    onCardLeave: function (e) {
      var video = e.currentTarget.querySelector('video')
      if (video) {
        video.pause()
        video.currentTime = 0
        if (this._playingVideo === video) {
          this._playingVideo = null
        }
      }
    },
    onAppClick: function () {
      this.$emit('select')
    }
  }
}
</script>

<style scoped>
/* ── section 模式（首页内嵌） ─────────────── */
.apps-mode-section {
  width: 100%;
}
.apps-section-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
}
.apps-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #8b8fa3;
}
.apps-section-tabs {
  display: flex;
  gap: 6px;
}
.apps-section-tab {
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #8b8fa3;
  background: #fff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s;
}
.apps-section-tab:hover {
  color: #1a1a2e;
  border-color: #ccc;
}
.apps-section-tab.active {
  color: #059669;
  border-color: #059669;
  background: rgba(5, 150, 105, 0.06);
  font-weight: 600;
}
.apps-section-grid {
  column-count: 4;
  column-gap: 20px;
}
.apps-section-card {
  position: relative;
  display: inline-block;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.2s;
  cursor: pointer;
  text-decoration: none;
  margin-bottom: 20px;
  break-inside: avoid;
}
.apps-section-card:hover {
  box-shadow: 0 6px 24px rgba(5, 150, 105, 0.12);
  transform: translateY(-3px);
}
.apps-section-card-img,
.apps-section-card-video {
  width: 100%;
  object-fit: cover;
  display: block;
}
/* 图片型卡片：按原始比例自然撑开，不裁切（posters / interior / comic） */
.apps-section-card.is-image .apps-section-card-img {
  height: auto;
}
/* 视频型卡片：统一 16:9 裁切，并按位置交错高度 */
.apps-section-card.is-video .apps-section-card-video {
  height: auto;
  aspect-ratio: 16/9;
}
.apps-section-card.is-video:nth-child(5n+1) .apps-section-card-video {
  aspect-ratio: 4/3;
}
.apps-section-card.is-video:nth-child(5n+3) .apps-section-card-video {
  aspect-ratio: 3/4;
}
.apps-section-card.is-video:nth-child(5n+5) .apps-section-card-video {
  aspect-ratio: 1/1;
}
.apps-section-card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 16px 14px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.55));
  text-align: center;
}
.apps-section-card-name {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

/* ── modal 模式（弹窗内） ─────────────────── */
.apps-modal-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 20px;
}
.apps-modal-tab {
  padding: 10px 20px;
  border-radius: 22px;
  font-size: 15px;
  color: #555;
  background: #f3f4f6;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
}
.apps-modal-tab.active {
  background: #059669;
  color: #fff;
  font-weight: 600;
  border-color: #059669;
}
.apps-modal-tab:hover:not(.active) {
  border-color: #059669;
  color: #059669;
}
.apps-modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}
.apps-modal-card {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  aspect-ratio: 16/10;
  display: block;
  text-decoration: none;
}
.apps-modal-card-video,
.apps-modal-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.apps-modal-card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 28px 12px 10px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
  text-align: center;
}
.apps-modal-card-name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

/* ── 响应式 ──────────────────────────────── */
@media (max-width: 1024px) {
  .apps-section-grid {
    column-count: 3;
  }
}
@media (max-width: 768px) {
  .apps-section-grid {
    column-count: 2;
    column-gap: 12px;
  }
  .apps-section-card {
    margin-bottom: 12px;
  }
  .apps-section-card-name {
    font-size: 14px;
  }
}
</style>
